import type {BaseComponentPart} from '@Components/ai-chat-window/lib/stream-component-registry.types';
import type {StreamComponentType} from '@Components/ai-chat-window/lib/stream-component-registry.types';

/** No props: the placeholder looks the same while the tool loads and while it searches. */
export type WebSourcesSkeletonProps = Record<string, never>;

export type WebSourcesSkeletonComponentPart = BaseComponentPart<StreamComponentType.WEB_SOURCES_SKELETON, WebSourcesSkeletonProps>;

export const SKELETON_FAVICON_COUNT = 3;
export const SKELETON_FAVICON_SIZE = 20;
